import * as React from "react";
import { forwardRef } from "react";
const SvgAlignIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15.75 8.2575L2.25 8.25V9.75H15.75V8.2575ZM2.25 12H11.25V13.5H2.25V12ZM15.75 4.5H2.25V6.0075L15.75 6V4.5Z", fill: "#4555D6" }));
const ForwardRef = forwardRef(SvgAlignIcon);
export { ForwardRef as ReactComponent };
